<template>
  <div class="page-wrapper compact-wrapper" id="pageWrapper">

    <div class="error-wrapper">
      <div class="container">
        <div class="svg-wrapper">
          <error403 />
        </div>
        <div class="col-md-8 offset-md-2">
          <h3>Sorry, Something Goes Wrong</h3>
          <p class="sub-content">The page you are attempting to reach is currently not available. This may be because the
            page does not exist or has been moved.</p><router-link class="btn btn-primary" :to="{ path: '/' }">BACK TO
            HOME PAGE</router-link>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import error403 from "./svg/error403Page.vue"
export default {
  components: {
    error403
  }
}
</script>
